import {
  GET_BANK_ACCOUNTS_REQUEST,
  GET_BANK_ACCOUNTS_SUCCESS,
  GET_BANK_ACCOUNTS_FAILURE,
  DELETE_BANK_ACCOUNT_SUCCESS,
  DELETE_BANK_ACCOUNT_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  isFetched: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BANK_ACCOUNTS_REQUEST:
      return { ...state, isLoading: true, error: null, isFetched: false };

    case GET_BANK_ACCOUNTS_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null,
        isFetched: true
      };

    case GET_BANK_ACCOUNTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, isFetched: true };

    case DELETE_BANK_ACCOUNT_SUCCESS: {
      const newBanks = state.data.filter(
        account => account.bankAccount.iban !== action.payload.iban
      );

      return { ...state, data: newBanks, isFetched: true };
    }
    case DELETE_BANK_ACCOUNT_FAILURE:
      return { ...state, error: action.payload, isFetched: true };

    default:
      return state;
  }
};
